export default "__VITE_ASSET__DaB5s288__"